import React from "react";
import PasswordForm from "../components/PasswordForm";

const ChangePassword = () => {
  return (
    <div className="container mt-4">
      <h2>Cambiar contraseña</h2>
      <PasswordForm />
    </div>
  );
};

export default ChangePassword;
